<template>
  <v-card>
    <v-form>
      <v-card-title primary-title>
        <h5 class="subheading mb-0">Bulk SMS</h5>
        <v-spacer></v-spacer>
           <v-btn icon flat :loading="sloading" color="green" v-if="!(sms_balance && site_online)" @click="reloadBalance()">
              <v-icon>refresh</v-icon>
            </v-btn>
        <span>{{sms_balance && site_online ?sms_balance+" sms remaining":"no sms balance or network error"}}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-layout row wrap>
            <!-- title -->
            <v-flex xs12>
              <v-autocomplete
                label="Send To:"
                :items="recipients"
                v-model="rcpts_model"
                outline
                :rules="validRules.required"
              ></v-autocomplete>
            </v-flex>

            <!-- custom numbers -->
            <v-flex xs12 v-if="rcpts_model === 'Custom Numbers'">
              <v-textarea
                label="Recipient numbers (comma separated)"
                v-model="custom_numbers"
                outline
                rows="6"
                :rules="customNumbersRules"
              ></v-textarea>
            </v-flex>

            <!-- message box -->
            <v-flex xs12>
              <v-textarea
                filled
                outline
                auto-grow
                label="Message"
                rows="4"
                row-height="30"
                shaped
                v-model="msg"
                :rules="validRules.required"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :loading="sloading" @click="sendsms()">Send</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Form from "vform";
import { mapGetters } from "vuex";

export default {
  name: "profile-view",
  layout: "admin",
  data: () => ({
    recipients: ["Whole School", "Staff", "Guardians", "Custom Numbers"],
    rcpts_model: "",
    custom_numbers: "",
    msg: "",
    site_online: false,
    sms_senderid: "",
    sms_apiKey: ""
  }),

  computed: {
    customNumbersRules() {
      return [
        v =>
          !v ||
          v.trim() === "" ||
          v
            .split(",")
            .every(n => n.trim() !== "" && /^\+?[0-9]{6,15}$/.test(n.trim())) ||
          "Enter comma separated phone numbers e.g. 0501111111,0244444444"
      ];
    },
    ...mapGetters({
      user: "authUser",

      settings: "settings/SETTINGS",
      errors: "settings/SETTING_ERROR",
      loading: "settings/SETTING_LOADING",

      sms_balance: "sms/SMS_BALANCE",
      serrors: "sms/SMS_ERROR",
      sloading: "sms/SMS_LOADING",
      sms_recipients: "sms/SMS_RCPTS"
    })
  },

  created() {
    this.site_online = navigator.onLine ? true : false;
    this.$store.dispatch("settings/getAll");

    const sms = this.settings.sms || {};
    this.sms_senderid = sms.senderid;
    this.sms_apiKey = sms.apiKey;
    if (this.site_online && this.sms_apiKey) {
       this.$store.dispatch("sms/getBalance");
    }

    this.$store.dispatch("sms/getRecipients");
  },

  methods: {
     reloadBalance(){
      this.$store.dispatch("sms/getBalance");
       this.site_online = navigator.onLine ? true : false;

       if(!this.site_online){


         this.$store.dispatch("responseMessage", {
              type: "warning",
              text:
                "Please check your network.",
              title: "SMS",
              modal: false
            });
       }
    },
    async sendsms() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let rcpts = "";

      if (!navigator.onLine) {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text:
            "Sorry, message could not be sent, please check your internet connection.",
          title: "SMS",
          modal: false
        });
        return;
      }

      if (this.sms_balance < 1) {
            this.$store.dispatch("responseMessage", {
              type: "warning",
              text:
                "Sorry,your balance is insufficient for this message. Please tell administrator to recharge sms balance.",
              title: "SMS",
              modal: false
            });

            return;
      }

      if (this.rcpts_model == "Whole School") {
        rcpts = this.sms_recipients.ws ? this.sms_recipients.ws.toString() : "";
      } else if (this.rcpts_model == "Staff") {
        rcpts = this.sms_recipients.stf
          ? this.sms_recipients.stf.toString()
          : "";
      } else if (this.rcpts_model == "Guardians") {
        rcpts = this.sms_recipients.grd
          ? this.sms_recipients.grd.toString()
          : "";
      } else if (this.rcpts_model == "Custom Numbers") {
        rcpts = this.custom_numbers.trim();
      } else {
        this.$store.dispatch("responseMessage", {
            type: "warning",
            text: "Please select who to send this SMS to.",
            title: "SMS",
            modal: false
          });
        return;
      }

      if (!rcpts) {
        this.$store.dispatch("responseMessage", {
            type: "warning",
            text: "Sorry,there are no recipients for this SMS.",
            title: "SMS",
            modal: false
          });
        return;
      }

      try {
        await this.$store.dispatch("sms/send", {
          to: rcpts,
          msg: this.msg
        });

        this.msg = "";
        this.rcpts_model = "";
        this.custom_numbers = "";
        this.$store.dispatch("responseMessage", {
          type: "success",
          text: "SMS sent successfully.",
          title: "SMS",
          modal: false
        });

        setTimeout(() => {
          this.$store.dispatch("sms/getBalance");
        }, 1000);
      } catch (e) {
        this.$store.dispatch("responseMessage", {
          type: "warning",
          text: "Sorry,an error occured whiles sending SMS.",
          title: "SMS",
          modal: false
        });
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/pages/admin/bulksms/bulksms.vue